import React from "react";
import PageLayout from "../../component/PageLayout";

export default function NotFound() {
  return (
    <div className="home-main">
      <PageLayout>   
        <div className="container">
          <div className="topspace">
        <div className="box-default w-full lg:w-1/2 m-auto text-center pt-14 pb-10 rounded-3xl">
        <div className="flex container-content justify-center items-center">
            <p>4</p>
                <span>😔
                <div className="searchiconerror">
                    🔎
                </div>
                </span>               
            <p>4</p>
        </div>
      <p className="text-2xl mb-0 mt-9">Page not found.</p>
      </div>
   </div>
   </div>
      </PageLayout>
    </div>
  );
}
